module.exports = __webpack_public_path__ + "static/img/Q.7a601c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cowboy/Q.png
// module id = 21wW
// module chunks = 0